export default {"src":"/_next/static/media/antique no 6.b2eaeca7.svg","height":73,"width":635};